import { render } from "./LowCode.vue?vue&type=template&id=59340126&scoped=true"
import script from "./LowCode.vue?vue&type=script&lang=js"
export * from "./LowCode.vue?vue&type=script&lang=js"

import "./LowCode.vue?vue&type=style&index=0&id=59340126&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59340126"]])

export default __exports__